import React from 'react'
import _ from 'lodash'
import { Map, Marker, TileLayer } from 'react-leaflet'
import Control from 'react-leaflet-control'
import NKIcon from '@norkart/ikoner'
import L from 'leaflet'

import { Maalerstatus } from '../../../felles/utils/statuskoder'
import FastMarkerLayer from '../../../felles/Kart/super-marker-cluster'
import PolygonSelection from '../../../felles/Kart/PolygonSelection'

import VannmaalerPopup from './VannmaalerPopup'
import PlanlagtPopup from './PlanlagtPopup'

import './kartRediger.css'

const calculateBounds = maalere => {
    let maxlat = 0
    let minlat = 90
    let maxlng = 0
    let minlng = 90

    maalere.forEach(m => {
        if (m.Latitude != null && m.Latitude > maxlat) maxlat = m.Latitude
        if (m.Latitude != null && m.Latitude < minlat) minlat = m.Latitude
        if (m.Longitude != null && m.Longitude > maxlng) maxlng = m.Longitude
        if (m.Longitude != null && m.Longitude < minlng) minlng = m.Longitude
    })

    if (maxlat > 0) {
        let southWest = L.latLng(minlat, minlng),
            northEast = L.latLng(maxlat, maxlng),
            bounds = L.latLngBounds(southWest, northEast)
            
        bounds.rand = Math.random()
        return bounds
    }
}

export default class kart extends React.Component {
    maalerIcon = L.icon({
        iconUrl: process.env.PUBLIC_URL + '/images/markering-08.png',
        iconSize: [40, 40]
    })

    maalerMarkerOptions = {
        radius: 6,
        color: '#000',
        fillColor: '#52A4A7',
        fillOpacity: 0.5,
        weight: 1,
        className: 'vannmaaler'
    }

    maalerIArblisteMarkerOptions = {
        radius: 6,
        color: '#000',
        fillColor: '#f5ad4a',
        fillOpacity: 0.5,
        weight: 1,
        className: 'vannmaaler'
    }

    maalerValgtMarkerOptions = {
        radius: 7,
        color: '#000',
        fillColor: '#f5ad4a',
        fillOpacity: 0.5,
        weight: 1,
        className: 'vannmaaler valgt'
    }

    planlagtIcon = L.icon({
        iconUrl: process.env.PUBLIC_URL + '/images/kartikon-planlagt.png',
        iconSize: [40, 40]
    })

    popup = VannmaalerPopup.bind(this, d => this._leggTilVannmaaler(d))
    boundsBuffer = { padding: [50, 50] }

    constructor(props) {
        super(props)

        let startBounds = undefined
        if (props.planlagte && props.planlagte.length)
            startBounds = calculateBounds(props.planlagte)
        else if (props.vannmaalere && props.vannmaalere.length)
            startBounds = calculateBounds(props.vannmaalere)
                        
        this.state = {
            vector: true,
            hybrid: false,
            hideLayerComponent: 'hide',
            startBounds
        }

        this._handleLayerComponentHide = this._handleLayerComponentHide.bind(this)
        this._handleBaseLayer = this._handleBaseLayer.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.valgtPlanlagtMaaler !== this.props.valgtPlanlagtMaaler &&
            nextProps.valgtPlanlagtMaaler
        ) {
            let valgtMaaler = _.find(
                nextProps.planlagte,
                m => nextProps.valgtPlanlagtMaaler === m.MaalerId
            )
            if (valgtMaaler)
                this.setState(s => ({
                    startBounds: calculateBounds([valgtMaaler])
                }))

            } else if (
            nextProps.planlagte !== this.props.planlagte &&
            !this.props.planlagte
        ) {
            this.setState(s => ({
                startBounds: calculateBounds([nextProps.vannmaalere])
            }))

        } else if (
            nextProps.vannmaalere !== this.props.vannmaalere &&
            !this.props.vannmaalere && 
            !this.state.startBounds
        ) {
            this.setState(s => ({
                startBounds: calculateBounds(nextProps.vannmaalere)
            }))
        }
    }

    _getCustomMarkerIcon(status) {
        var ikon = null

        if (status < Maalerstatus.Skiftet) {
            ikon = L.icon({
                iconUrl: process.env.PUBLIC_URL + '/images/kartikon-planlagt.png',
                iconSize: [40, 40]
            })
        }

        if (status === Maalerstatus.Skiftet) {
            ikon = L.icon({
                iconUrl: process.env.PUBLIC_URL + '/images/kartikon-utfoert.png',
                iconSize: [40, 40]
            })
        }

        if (status === Maalerstatus.IkkeSkiftet) {
            ikon = L.icon({
                iconUrl: process.env.PUBLIC_URL + '/images/kart_ikkeskiftet.png',
                iconSize: [40, 40]
            })
        }
        return ikon
    }

    _handleLayerComponentHide() {
        var hide = this.state.hideLayerComponent
        if (hide === 'hide') {
            this.setState({ hideLayerComponent: ' ' })
        } else {
            this.setState({ hideLayerComponent: 'hide' })
        }
    }

    _handleBaseLayer(changeEvent) {
        var lay = changeEvent.target.value

        switch (lay) {
            case 'vector':
                this.setState({
                    vector: true,
                    hybrid: false
                })
                break
            case 'hybrid':
                this.setState({
                    vector: false,
                    hybrid: true
                })
                break
            default:
                this.setState({
                    vector: true,
                    hybrid: false
                })
        }
    }

    _leggTilVannmaaler(data) {
        if (this.props.leggTilMaaler) this.props.leggTilMaaler(data)
    }

    _fjernVannmaaler(data) {
        if (this.props.fjernMaaler) this.props.fjernMaaler(data)
    }

    render() {
        const { valgteMaalere, vannmaalere, viewport, filter, onViewportChanged, onFilterChanged } = this.props

        
        let maalereSomSkalVises = _.filter(vannmaalere, m => m.Latitude > 0 && !m.ErIArbeidsliste)
        
        let maalereIAndreArblister = _.filter(vannmaalere, m => m.ErIArbeidsliste &&  m.Latitude > 0)

        maalereSomSkalVises = _.reject(maalereSomSkalVises, 
            m => _.some(valgteMaalere, v => v.Id === m.Id))

        let viewOptions = {}
        if (viewport) {
            viewOptions.viewport = viewport
        } else {
            viewOptions.bounds = this.state.startBounds
            viewOptions.boundsOptions = this.boundsBuffer
        }

        return (
            <div className="vm-kart-rediger">
                <Map
                    maxZoom={19}
                    zoomControl={false}
                    onViewportChanged={onViewportChanged}
                    {...viewOptions}
                >
                    {this.state.vector && (
                        <TileLayer
                            url="//www.webatlas.no/maptiles/tiles/webatlas-gray-vektor/wa_grid/{z}/{x}/{y}.png"
                            maxZoom={20}
                        />
                    )}

                    {this.state.hybrid && (
                        <TileLayer
                            url="//www.webatlas.no/maptiles/tiles/webatlas-standard-hybrid/wa_grid/{z}/{x}/{y}.jpeg"
                            maxZoom={20}
                        />
                    )}

                    <PolygonSelection activeSelection={filter.polygon} 
                        onSelectionChanged={polygon => onFilterChanged({polygon})} 
                        />

                    <Control position="topright">
                        <div>
                            <button
                                type="button"
                                className="btnLag"
                                onClick={this._handleLayerComponentHide}
                            >
                                <NKIcon icon="lag" color="nk-black" />
                            </button>
                            <div className={'layerComponent ' + this.state.hideLayerComponent}>
                                <button
                                    type="button"
                                    value="vector"
                                    onClick={this._handleBaseLayer}
                                    className="btn btn-primary w150"
                                >
                                    Kart
                                </button>{' '}
                                <br />
                                <button
                                    type="button"
                                    value="hybrid"
                                    onClick={this._handleBaseLayer}
                                    className="btn btn-default w150"
                                >
                                    Flyfoto
                                </button>{' '}
                                <br />
                            </div>
                            <br />
                        </div>
                    </Control>

                    {maalereSomSkalVises &&
                        maalereSomSkalVises.length && (
                            <FastMarkerLayer
                                data={maalereSomSkalVises}
                                icon={this.maalerIcon}
                                markerOptions={this.maalerMarkerOptions}
                                markerPopup={this.popup}
                                disableClusteringAtZoom={15}
                            />
                        )}

                    {maalereIAndreArblister &&
                    maalereIAndreArblister.length > 0 && (
                        <FastMarkerLayer
                                data={maalereIAndreArblister}
                                icon={this.planlagtIcon}
                                markerOptions={this.maalerIArblisteMarkerOptions}
                                markerPopup={this.popup}
                                disableClusteringAtZoom={15}
                            />
                    )

                    }

                    {this.props.planlagte.map((maaler, index) => (
                        <Marker
                            position={[maaler.Latitude, maaler.Longitude]}
                            icon={this.planlagtIcon}
                            key={maaler.MaalerId}
                        >
                            <PlanlagtPopup maaler={maaler} fjernVannmaaler={d => this._fjernVannmaaler(d)} />
                        </Marker>
                    ))}
                </Map>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/planlegging/arbeidsliste/rediger/kartRediger.jsx